import _ from "lodash";
import { Fragment, memo, useCallback, useMemo } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import SelectComponent from "../../_Components/ReactSelectComponent"
import AddCircleRounded from "@mui/icons-material/AddCircleOutlineRounded";
import ReserveItemGroup from "./ReserveItemGroup";


const CreateReserveFormDate = ({
  formatTime,
  reserveDetail,
  reserveDescriptions,
  reserveItemGroups,
  reserveItems,
  date,
  setModalNameDate,
  setShowModalAddDescription,
}) => {
  const { register, control } = useFormContext()
  const nameDate = useMemo(() => date.nameDate, [date]);
  const reserveDetailDate = useMemo(() => _.isArray(reserveDetail.reserveDetailJson)
    ? _.find(reserveDetail.reserveDetailJson, { d: nameDate })
    : "", [reserveDetail, nameDate]);

  const openModalAddDescription = useCallback((nameDate, groupId) => {
    var formattedNameDate = "";
    if (groupId != 0) {
      formattedNameDate = `${nameDate}-${groupId}-Des`;
    } else {
      formattedNameDate = `${nameDate}-Des`;
    }
    setModalNameDate(formattedNameDate);
    setShowModalAddDescription(true);
  }, [setModalNameDate, setShowModalAddDescription]);

  return (
    <>
      {
        !_.isUndefined(reserveItemGroups) &&
        !_.isEmpty(reserveItemGroups) &&
        reserveItemGroups.length > 0 &&
        !_.isUndefined(reserveItems) &&
        !_.isEmpty(reserveItems) &&
        <Col key={nameDate} xs="12" className="mt-2 ">
          <Col className="rounded-3" style={{ border: "1px solid #a2a6b9" }}>
            <Row className="justify-content-md-right py-3 " style={{ backgroundColor: "#c6cad7" }}>
              <Col xs="12" sm="7" className="pt-2 position-relative">
                <input
                  key={reserveDetail.service.toString() + `${nameDate}-IA`}
                  name={`${nameDate}-IA`}
                  {...register(`${nameDate}-IA`)}
                  type="checkbox"
                  style={{ margin: "0 5px" }}
                  title="فعال/غیرفعال"
                  defaultChecked={reserveDetailDate && reserveDetailDate.dIA != null ? reserveDetailDate.dIA : false}
                />

                {date.formattedDate + " " + date.persianDayOfWeek}
              </Col>
              <Col xs="10" sm="5" className="mt-2 mt-md-0 pr-2 d-flex align-items-center">
                <Controller
                  name={`${nameDate}-Des`}
                  control={control}
                  render={(field) => (
                    <SelectComponent
                      className="w-100"
                      variant="outlined"
                      size="small"
                      placeholder="توضیحات تاریخ"
                      noLabel
                      options={reserveDescriptions.map(item => ({ ...item, label: item.label.length > 40 ? item.label.slice(0, 40) + "…" : item.label }))}
                      {...field}
                    />
                  )}
                />
                <Button
                  onClick={() => openModalAddDescription(nameDate, 0)}
                  variant="light h-100 mx-1"
                >
                  <AddCircleRounded
                    fontSize="large"
                    className="big-icon"
                  />
                </Button>

              </Col>
            </Row>
            <div>
              {reserveItemGroups.map(function (group, index) {
                let reserveDetailGroup =
                  reserveDetailDate && _.isArray(reserveDetailDate.g)
                    ? _.find(reserveDetailDate.g, { gId: group.id })
                    : "";

                return (
                  <Fragment key={index}>
                    {!_.isUndefined(group) && !_.isEmpty(group) &&
                      <ReserveItemGroup
                        nameDate={nameDate}
                        group={group}
                        reserveDescriptions={reserveDescriptions}
                        reserveDetailGroup={reserveDetailGroup}
                        reserveDetail={reserveDetail}
                        openModalAddDescription={openModalAddDescription}
                        reserveItems={reserveItems}
                        formatTime={formatTime}
                        reserveDetailDate={reserveDetailDate}
                      />
                    }
                  </Fragment>
                )
              })}
            </div>
          </Col>
        </Col>
      }
    </>

  );
};

export default memo(CreateReserveFormDate)